/**
 * Product naming workflow (#1110).
 *
 * A proposed name is attached to an EXISTING product and never creates one
 * (09-23: a suggestion created a second product). Approving a proposal writes
 * `metadata.name` through the normal product update, so the rename propagation
 * from #1109 (Asana, SharePoint, barcodes, physical assets) runs unchanged.
 */
import { navFeatureId } from './feature-visibility.js';
export const NAME_PROPOSAL_STATUSES = ['proposed', 'in_review', 'approved', 'rejected'];
/** Statuses still waiting on someone. The review queue lists these. */
export const OPEN_NAME_PROPOSAL_STATUSES = ['proposed', 'in_review'];
export const NAME_PROPOSAL_STATUS_LABELS = {
    proposed: 'Proposed',
    in_review: 'In review',
    approved: 'Approved',
    rejected: 'Rejected',
};
/**
 * The Asana task that status changes are posted to, plus the older template
 * names for it (same list as `TEMPLATE_RENAMES` in the PDLC Board's boardModel).
 */
export const FINALIZE_PRODUCT_NAME_TASK_NAMES = [
    'Finalize Product Name',
    'Finalize Product Naming',
    'Final Product Name',
];
export const MARKETING_NAMING_PATH = '/marketing/naming';
export const MARKETING_NAMING_FEATURE = navFeatureId(MARKETING_NAMING_PATH);
/** `metadata.action` of the activity row a rename report is stored in. */
export const PRODUCT_RENAME_ACTION = 'product_rename';
//# sourceMappingURL=product-naming.js.map